import { MathUtils, PlatformUtils } from "../Utils";

export class AppConfig implements PIXI.ApplicationOptions {
    // index signature
    [key: string]: any;
    public autoStart?: boolean;
    public width?: number;
    public height?: number;
    public view?: HTMLCanvasElement;
    public transparent?: boolean;
    public antialias?: boolean;
    public preserveDrawingBuffer?: boolean;
    public resolution?: number;
    public forceCanvas?: boolean;
    public backgroundColor?: number;
    public clearBeforeRender?: boolean;
    public roundPixels?: boolean;
    public forceFXAA?: boolean;
    public legacy?: boolean;
    public powerPreference?: "high-performance";
    public sharedTicker?: boolean;
    public sharedLoader?: boolean;
    public autoResize?: boolean;

    constructor(pConfig?: any) {
        // If no config is provided, create a default one
        if (pConfig === undefined) {
            pConfig = {
                autoResize: true,
                resolution: PIXI.utils.isMobile.any === false ? 2 :
                    (window.devicePixelRatio > 1 ? 2 : 1),
            };
        }
        else {
            // If a config is provided but particular properties are not set that need to be, do your sanity checks here.
            if (pConfig.autoResize === undefined || pConfig.autoResize === false) {
                pConfig.autoResize = true;
            }
        }

        // If the resolution is set to anything other than a number, determine the resolution from runtime check
        if (typeof pConfig.resolution !== "number") {
            this.resolution = PIXI.utils.isMobile.any === false ? 2 :
                (window.devicePixelRatio > 1 ? 2 : 1);
        }
        else {
            // Ensure that the resolution is either 1 or 2 only
            this.resolution = pConfig.resolution;
            this.resolution = Math.round(this.resolution!);
            this.resolution = MathUtils.clamp(this.resolution, 1, 2);
        }

        // Automatically enable the Amazon fix if we are on Amazon
        /**
         * This is used to handle a flicker that occurs when playing app on an Amazon OS device.
         * PIXI suggests enabling preserveDrawingBuffer on these devices so that was the initial course of action. PIXI
         * warned that this could cause performance issues.
         * Feedback from a client suggested that using transparent would yield the intended result with less side
         * effects.
         *  if (pConfig.preserveDrawingBuffer !== undefined) {
         *      this.preserveDrawingBuffer = pConfig.preserveDrawingBuffer;
         *  }
         *  else {
         *      this.preserveDrawingBuffer = PlatformUtils.isAmazonOS();
         *  }
         */
        if (pConfig.transparent !== undefined) {
            this.transparent = pConfig.transparent;
        }
        else {
            this.transparent = PlatformUtils.isAmazonOS();
        }

        // If properties exist in the json, set them in the config
        for (const key in pConfig) {
            if (pConfig.hasOwnProperty(key)) {
                if (key === "resolution" ||
                    /**
                     * See the above comment block
                     */
                    // key === "preserveDrawingBuffer") {
                    key === "transparent") {
                    continue;
                }
                else {
                    this[key] = pConfig[key];
                }
            }
        }
    }
}
